// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  stripe: {
    publicKey: "pk_live_51TwzyQ2K3pfFdm7cI47p0EMYQUCZAekwshvoqvU3pCMA0jCzI5lvCjwrxJlOWjrHQ9pBF2vLQ2UT74fSHjEGw3dc00taQssmxq",
    apiUrl: "https://8zuyq0lpse.execute-api.us-west-1.amazonaws.com",
    site: "verde"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

